<template>
  <div class="page-content" id="device-form">
    <Titlebar :incrustation="'beepiz-folder'" :backPath="'/devices/groups'">
      <h1>{{ pageTitle }}</h1>
    </Titlebar>
    <div class="row justify-content-center">
      <div class="col-6">
        <UiCard class="mb-3">
          <FormLabel>
            <i class="fa beepiz-folder fa-lg mr-2"></i>
            {{ $t("device.group.form.label") }}
          </FormLabel>
          <FormWrapper>
            <FormControl>
              <FormInput
                v-model="nameGroup"
                name="nameGroup"
                :isInvalid="groupNameShowError"
              />
              <FormError v-if="groupNameShowError && !groupNameIsValid">
                {{ $t("device.registrations.errors.label_needed") }}
              </FormError>
            </FormControl>
          </FormWrapper>
        </UiCard>

        <UiCard>
          <div @click="collapseUsers = !collapseUsers">
            <FormLabel
              style="display: block; width: 100%; margin-bottom: 0.5rem"
            >
              <i class="fa fa-users fa-lg mr-2"></i>
              {{ $t("device.group.users") }}
              <i
                :class="[
                  'fa fa-chevron-right float-right transform transition-transform duration-200',
                  collapseUsers ? '' : 'rotate-90',
                ]"
              ></i>
            </FormLabel>
          </div>

          <div v-show="!collapseUsers">
            <FormControl>
              <SelectList :list="usersList" itemType="nom" />
            </FormControl>
          </div>
        </UiCard>
      </div>
      <div class="col-6" v-can="'beepiz-select-devices'">
        <UiCard>
          <div @click="devices = !devices" style="margin-bottom: 0.5rem">
            <FormControl>
              <FormLabel style="display: block; width: 100%">
                <i class="fa fa-mobile-phone fa-lg text-2xl mr-2"></i
                >{{ $t("device.group.devices") }}
                <i
                  :class="[
                    'fa fa-chevron-right float-right transform transition-transform duration-200',
                    devices ? '' : 'rotate-90',
                  ]"
                ></i>
              </FormLabel>
            </FormControl>
          </div>

          <div v-show="!devices">
            <FormControl>
              <SelectList :list="devicesList" itemType="dati" />
            </FormControl>
          </div>
        </UiCard>

        <UiCard
          class="mt-4"
          v-show="useDvFlagAccess('beepiz-group-licenses-unregistred-can:read')"
        >
          <div
            @click="licenses = !licenses"
            style="margin-bottom: 0.5rem; cursor: pointer"
          >
            <FormControl>
              <FormLabel style="display: block; width: 100%">
                <i class="fa fa-mobile-phone fa-lg text-2xl mr-2"></i
                >{{ $t("device.group.devices_available") }}
                <i
                  :class="[
                    'fa fa-chevron-right float-right transform transition-transform duration-200',
                    licenses ? '' : 'rotate-90',
                  ]"
                ></i>
              </FormLabel>
            </FormControl>
          </div>

          <div v-show="!licenses">
            <FormControl>
              <SelectList :list="devicesAvailableList" itemType="dati" />
            </FormControl>
          </div>
        </UiCard>
      </div>
    </div>

    <Toolbar>
      <Btn
        :class="'primary pull-right'"
        :disabled="!groupNameIsValid || !canSave"
        @click.native.stop="validForm()"
        v-if="canSave"
        >{{ $t("global.save") }}
      </Btn>
      <Btn :class="'pull-right'">
        <router-link to="/devices/groups" tag="span">{{
          $t("global.cancel")
        }}</router-link>
      </Btn>
    </Toolbar>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import API from "@/services/API.js";
import Auth from "@/services/auth.js";
import SelectList from "@/components/ui/fields/SelectList";
import {
  FormControl,
  FormLabel,
  FormInput,
  FormWrapper,
  FormError,
} from "@/components/ui/forms";
import Titlebar from "@/components/ui/Titlebar";
import Toolbar from "@/components/ui/Toolbar";
import Btn from "@/components/ui/Button";
import UiCard from "@/components/ui/Card";
import FilterField from "@/components/ui/Filter";

import Utils from "@/services/utils.js";

import find from "lodash/find";
import { useDvFlagAccess } from "../../../services/featureFlag";

var sha1 = require("sha1");

export default {
  name: "GroupForm",
  components: {
    Titlebar,
    Toolbar,
    Btn,
    UiCard,
    FilterField,
    SelectList,
    FormWrapper,
    FormControl,
    FormLabel,
    FormInput,
    FormError,
  },
  computed: {
    groupNameIsValid: function () {
      return !!this.nameGroup && this.nameGroup.trim().length > 0;
    },
    groupNameShowError: function () {
      return !this.groupNameIsValid;
    },
    canSave() {
      return useDvFlagAccess("beepiz-group-can:update");
    },
    pageTitle: function () {
      if (this.editMode) {
        return this.nameGroup;
      } else {
        return Utils.t("device.group.titles.new");
      }
    },
  },
  // Correction ici : Utilisation d'une fonction standard pour la réactivité
  data() {
    return {
      editMode: false,
      groupId: null,
      nameGroup: "",
      devicesList: [],
      devicesAvailableList: [],
      usersList: [],
      usersGroup: [],
      devices: false,
      licenses: false,
      collapseUsers: true,
    };
  },

  methods: {
    useDvFlagAccess,
    validForm: function () {
      if (!this.canSave) return;
      window.Vfc.$refs.loading.show();
      var selectedDevices = [];
      var selectedUsers = [];
      for (var dKey in this.devicesList) {
        var item = this.devicesList[dKey];
        if (item.children != null && item.children.length > 0) {
          for (var cKey in item.children) {
            var child = item.children[cKey];
            if (child.selected === true) {
              selectedDevices.push(child.id);
            }
          }
        } else {
          if (item.selected === true) {
            selectedDevices.push(item.id);
          }
        }
      }
      for (var dKey in this.devicesAvailableList) {
        var item = this.devicesAvailableList[dKey];
        if (item.children != null && item.children.length > 0) {
          for (var cKey in item.children) {
            var child = item.children[cKey];
            if (child.selected === true) {
              selectedDevices.push(child.id);
            }
          }
        } else {
          if (item.selected === true) {
            selectedDevices.push(item.id);
          }
        }
      }
      for (var ukey in this.usersList) {
        var user = this.usersList[ukey];
        if (user.selected === true) {
          selectedUsers.push(user.iduser);
        }
      }
      var objToEdit = {
        name: this.nameGroup,
        datis: selectedDevices,
        users: selectedUsers,
      };
      if (this.editMode) {
        axios
          .put(
            API.route(API.endpoints.groups.edit, { groupId: this.groupId }),
            objToEdit
          )
          .then((response) => {
            window.Vfc.$refs.messages.sendMessage(
              "success",
              Utils.t("global.dataSaved")
            );
            this.loadData();
          })
          .catch((error) => {
            window.Vfc.$refs.loading.hide();
            if (error.response && error.response.status == 422) {
              var message =
                window.V.$i18n.t("errors.e422") +
                " " +
                error.response.data.message;
              if (
                error.response.data.message.includes("_") &&
                window.V.$i18n.te(error.response.data.message)
              ) {
                message = window.V.$i18n.t(error.response.data.message);
              }
              window.Vfc.$refs.messages.sendMessage("error", message);
            }
          });
      } else {
        axios
          .post(API.endpoints.groups.add, objToEdit)
          .then((response) => {
            window.Vfc.$refs.messages.sendMessage(
              "success",
              Utils.t("global.dataSaved")
            );
            window.V._router.push(
              "/devices/groups/" + response.data.message,
              () => {
                this.loadData();
              }
            );
          })
          .catch(() => {
            window.Vfc.$refs.loading.hide();
          });
      }
    },

    loadData: function () {
      if (this.$route.params.id != null) {
        this.editMode = true;
        this.groupId = this.$route.params.id;
        axios
          .get(API.route(API.endpoints.groups.show, { groupId: this.groupId }))
          .then((response) => {
            this.nameGroup = response.data.name;
            this.usersGroup = response.data.users;
            this.loadUsers();
          });
      }
      this.loadDatis();
      if (!this.editMode) {
        this.loadUsers();
      }
    },

    loadDatis: function () {
      axios
        .get(API.endpoints.datis.newIndexByGroup + "?alldevices=1")
        .then((response) => {
          // Structure attendue : response.data = { devices: [...], licenses: [...] }
          const data = response.data;

          // Fonction pour injecter la réactivité "selected"
          const prepareList = (list) => {
            if (!list) return [];
            list.forEach((item) => {
              if (item.children && item.children.length > 0) {
                item.children.forEach((child) => {
                  Vue.util.defineReactive(child, "selected", false);
                  if (this.editMode && child.groupId == this.groupId) {
                    child.selected = true;
                  }
                });
              } else {
                Vue.util.defineReactive(item, "selected", false);
                if (this.editMode && item.groupId == this.groupId) {
                  item.selected = true;
                }
              }
            });
            return list;
          };

          // On traite les deux listes séparément
          this.devicesList = prepareList(data.datiRegistred);
          this.devicesAvailableList = prepareList(data.datiAvailable);

          window.Vfc.$refs.loading.hide();
        })
        .catch((error) => {
          console.error("Erreur API :", error);
          window.Vfc.$refs.loading.hide();
        });
    },
    loadUsers() {
      axios.get(API.route(API.endpoints.users.index)).then((response) => {
        this.usersList = response.data;
        for (var uKey in this.usersList) {
          var item = this.usersList[uKey];
          Vue.util.defineReactive(item, "selected", false);
          if (find(this.usersGroup, { iduser: item.iduser })) {
            item.selected = true;
          }
          if (!this.editMode && item.iduser == Auth.user.iduser) {
            item.selected = true;
          }
        }
      });
    },
  },
  mounted() {
    if (!useDvFlagAccess("beepiz-group-can:read")) {
      this.$router.push({ name: "AccessDenied", params: { slug: "groups" } });
    }
    this.loadData();
  },
};
</script>

<style scoped></style>
